module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-range-fill-6ce998c2.svg";